export default function canEditViewedRound(parm) {
  const isNextRound = parm.view_round == parm.arena_round + 1

  if (parm.view_round < parm.arena_round) {
    return false
  }

  if (parm.arena_round_completed) {
    return false
  }

  if (parm.arena_extra_ready && parm.view_round != parm.arena_round && !isNextRound) {
    return false
  }

  if (parm.arena_extra_action > 0 && parm.view_round != parm.arena_round && !isNextRound) {
    return false
  }

  return true
}
